export const GET_COMPETENCIES_START = 'GET_COMPETENCIES_START';
export const GET_COMPETENCIES__SUCCESS = 'GET_COMPETENCIES__SUCCESS';
export const GET_COMPETENCIES__FAIL = 'GET_COMPETENCIES__FAIL';
